// home.js
import React from 'react';
import config from '../../../../config/config';
import CustomList from '../Util/List/CustomList/CustomList';
import CustomListContainer from '../Util/List/CustomList/CustomListContainer';
import { loadData } from '../Util/List/CustomList/loadData';
import { useSelector } from 'react-redux';

import '../home/Home.css';

const Organization = () => {
    const sessionSelector = useSelector((state) => {
        return state.core.session;
    });
    const friendly_url = sessionSelector.pdc_project_friendly_url;

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'from_year',
                type: 'year',
                label: 'Ano de',
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'to_year',
                type: 'year',
                label: 'Ano até',
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 2
            }
        ]
    };

    const paths = {
        endpoint: config.endpoints.backend + 'portal/getallmedicalscales'
    };
    const list = {
        labelTitle: 'Escalas Médicas',
        icon: 'fa-briefcase-medical',
        filter: {
            friendly_url
        },
        formFilters: filters,
        canDownload: true,
        fieldToDownload: 'file',
        columns: [
            {
                name: 'type_specialty',
                label: 'Tipo - Especialidade'
            },
            {
                name: 'reference_date',
                label: 'Referência',
                width: '10%'
            }
        ]
    };

    return (
        <div
            style={{
                marginLeft: '35px'
            }}
        >
            <CustomListContainer
                canAdd={false}
                labelTitle={list.labelTitle}
                icon={list.icon}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
};

export default Organization;
